import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

interface TrendsQueryParams {
  oauthTokenHeader: string;
  queryId: string;
  startDate: string;
  endDate: string;
  timeUnit: string;
  websiteSharedUids?: string[]; // Multiple
  dimensions?: string[]; // Multiple
  type: string; // Single required
  campaignId?: string; // Optional single
  adgroupId?: string; // Optional single
  matchtype?: string; // Optional single
  kwId?: string; // Optional single
  country?: string; // Optional single
  trafficSource?: string; // Optional single
}

function getTrendsDashboardExecuteQuery1(params: TrendsQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    timeUnit,
    websiteSharedUids = [],
    dimensions = [],
    type,
    campaignId,
    adgroupId,
    matchtype,
    kwId,
    country,
    trafficSource,
  } = params;

  const searchParams = new URLSearchParams();

  // Required params
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("time_unit", timeUnit);
  searchParams.append("type", type);

  // Optional single-value params
  if (campaignId) searchParams.append("campaign_id", campaignId);
  if (adgroupId) searchParams.append("adgroup_id", adgroupId);
  if (matchtype) searchParams.append("matchtype", matchtype);
  if (kwId) searchParams.append("kw_id", kwId);
  if (country) searchParams.append("country", country);
  if (trafficSource) searchParams.append("traffic_source", trafficSource);
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;

  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension: dimensions,
  };

  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}
function getTrendsBreakdownExecuteQuery(params: TrendsQueryParams) {
  const {
    oauthTokenHeader,
    queryId,
    startDate,
    endDate,
    timeUnit,
    websiteSharedUids = [],
    dimensions = [],
    type,
    campaignId,
    adgroupId,
    matchtype,
    kwId,
    country,
    trafficSource,
  } = params;

  const searchParams = new URLSearchParams();

  // Required params
  searchParams.append("start_date", startDate);
  searchParams.append("end_date", endDate);
  searchParams.append("time_unit", timeUnit);
  searchParams.append("type", type);

  // Optional single-value params
  if (campaignId) searchParams.append("campaign_id", campaignId);
  if (adgroupId) searchParams.append("adgroup_id", adgroupId);
  if (matchtype) searchParams.append("matchtype", matchtype);
  if (kwId) searchParams.append("kw_id", kwId);
  if (country) searchParams.append("country", country);
  if (trafficSource) searchParams.append("traffic_source", trafficSource);
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;

  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension: dimensions,
  };

  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}
function getDimentions(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/dimensions/`,
    oauthTokenHeader,
  );
}

function getTrafficSourcesTrends(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/traffic_sources/`, oauthTokenHeader);
}
function getGeosTrends(oauthTokenHeader: string) {
  return fetchWrapper.get(`${apiUrl}/meta/geos/`, oauthTokenHeader);
}

function getFilterBizLayerQueryTrends(
  queryId: any,
  oauthTokenHeader: any,
  type: any,
  websiteSharedUids: any[] = [],
  dimensions: any[] = [],
  trafficSource: any,
  account_shared_uid?: any, // Add optional parameter
  campaign_status?: any,
) {
  const searchParams = new URLSearchParams();
  searchParams.append("type", type);

  if (trafficSource) searchParams.append("traffic_source", trafficSource);
  if (account_shared_uid !== undefined) {
    searchParams.append("account_shared_uid", account_shared_uid.toString());
  }
  if (campaign_status) {
    searchParams.append("campaign_status", campaign_status);
  }
  if (websiteSharedUids?.[0]) {
    searchParams.append("website_shared_uid", websiteSharedUids[0]);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;

  const requestBody = {
    website_shared_uid: websiteSharedUids,
    dimension: dimensions,
  };

  return fetchWrapper.post(fullUrl, requestBody, oauthTokenHeader);
}

function getActivityNotes(
  oauthTokenHeader: string,
  websiteSharedUid: string[],
  fromDate: string,
  toDate: string,
) {
  const searchParams = new URLSearchParams();
  websiteSharedUid.forEach((uid) => {
    searchParams.append("website_shared_uid", uid);
  });
  searchParams.append("from", fromDate);
  searchParams.append("to", toDate);

  const fullUrl = `${apiUrl}/asset_management/activity_notes/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getWebsitesInTrends(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/websites/`,
    oauthTokenHeader,
  );
}

// function getSingleActivityNoteTemp(
//   oauthTokenHeader: string,
//   website_shared_uid: any,
//   fromDate: any,
//   toDate: any
// ) {
//   return fetchWrapper.get(
//     `${apiUrl}/asset_management/activity_notes/?website_shared_uid=${website_shared_uid}&from=${fromDate}&to=${toDate}`,
//     oauthTokenHeader
//   );
// }

export const trendsService = {
  getDimentions,
  getTrendsDashboardExecuteQuery1,
  getTrafficSourcesTrends,
  getGeosTrends,
  getFilterBizLayerQueryTrends,
  getActivityNotes,
  // getSingleActivityNoteTemp,
  getTrendsBreakdownExecuteQuery,
  getWebsitesInTrends,
};
